import * as React from 'react';

function SvgCalendarFill(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='1em'
			height='1em'
			fill='currentColor'
			className='svg-icon'
			viewBox='0 0 16 16'
			{...props}>
			<path d='M3.5 0a.5.5 0 01.5.5V1h8V.5a.5.5 0 011 0V1h1a2 2 0 012 2v11a2 2 0 01-2 2H2a2 2 0 01-2-2V5h16V4H0V3a2 2 0 012-2h1V.5a.5.5 0 01.5-.5z' />
		</svg>
	);
}

export default SvgCalendarFill;
